import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'
import DateTime from 'react-datetime'
import { FormGroup, ControlLabel } from 'react-bootstrap'
import moment from 'moment'
import PropTypes from 'prop-types';

class DatePicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.value !== nextProps.value) {
      const value = nextProps.value ? moment(nextProps.value) : '';

      this.setState({
        value: value
      });

      if (value) {
        this.props.dispatch(actions.change(this.props.model, value.format()));
      }
    }
  }

  componentDidMount() {
    const { value, model, dispatch } = this.props;

    if (this.state.value === '') {
      this.componentWillReceiveProps({ value: value });
    } else {
      dispatch(actions.change(model, this.state.value));
    }
  }

  handleChange = (value, formattedValue) => {
    const { model, dispatch } = this.props;

    if (typeof value === 'object') {
      this.setState({
        value,
      });

      dispatch(actions.change(model, value.format()));
    } else {
      this.setState({
        value: '',
      });
      dispatch(actions.change(model, ''));
    }
  };

  render() {
    const { 
      controlId, label, timeFormat, dateFormat, classNames,
      disabled, placeholder, valid
    } = this.props;
    const { value } = this.state;

    return (
      <FormGroup className="ignite-datepicker"
                 controlId={controlId}>
        {label && <ControlLabel>{label}</ControlLabel>}
        <DateTime timeFormat={timeFormat}
                  dateFormat={dateFormat}
                  className={classNames}
                  inputProps={{
                    "disabled": disabled,
                    "placeholder": placeholder,
                    "autoComplete": `${+ new Date()}-${Math.random()}`, // Thanks to Chrome: https://bugs.chromium.org/p/chromium/issues/detail?id=587466
                  }}
                  closeOnSelect={!timeFormat}
                  value={value}
                  onChange={this.handleChange} 
                  isValidDate={valid} />
      </FormGroup>
    );
  }
}

DatePicker.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  dateFormat: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  timeFormat: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  disabled: PropTypes.any,
  valid: PropTypes.func
};

DatePicker.defaultProps = {
  dateFormat: 'DD/MM/YYYY',
  timeFormat: false
};

export default connect()(DatePicker);



// WEBPACK FOOTER //
// ./src/components/common/form/datepicker.jsx